export default __webpack_public_path__ + "static/winter2-45031a52614b49cfa4d1e95ec04331f2.webp";